export default "__VITE_ASSET__501f9bdf__"